import * as React from 'react';
import cn from 'classnames';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { groupRefundServicesByPassenger, groupServicesByType } from '../utils';
import Baggage from './Services/Baggage/Baggage';
import Meal from './Services/Meal/Meal';
import { useTheme } from '../../theme';
import Seat from './Services/Seat/Seat';
import Insurance from './Services/Insurance/Insurance';
import { useCallback } from 'react';
import { useRenderers } from '../../renderProps';
import { CardExtraViewSkeleton } from '@shared/ui/CardExtraView';
const RefundSummary = ({ className, flight, travellers, gdsServicesRefund, insurancesRefund, notification, isLoading, customWarningMessage, mode }) => {
    const theme = useTheme('RefundSummary').RefundSummary;
    const { RefundSummaryInsurance: RefundSummaryInsuranceOverride = Insurance } = useRenderers();
    const groupServices = React.useMemo(() => {
        var _a, _b;
        if ((_a = gdsServicesRefund === null || gdsServicesRefund === void 0 ? void 0 : gdsServicesRefund.GetGdsServicesRefundInfo) === null || _a === void 0 ? void 0 : _a.gdsServicesRefundInfo) {
            const servicesByType = groupServicesByType((_b = gdsServicesRefund === null || gdsServicesRefund === void 0 ? void 0 : gdsServicesRefund.GetGdsServicesRefundInfo) === null || _b === void 0 ? void 0 : _b.gdsServicesRefundInfo);
            const refundServicesByType = new Map();
            servicesByType.forEach((value, key) => {
                refundServicesByType.set(key, groupRefundServicesByPassenger(value));
            });
            return refundServicesByType;
        }
        return null;
    }, [gdsServicesRefund]);
    const getServiceCardByType = (refundServices, type) => {
        const props = {
            flight,
            passengers: travellers,
            services: refundServices,
            mode
        };
        switch (type) {
            case OrderAdditionalServiceGdsServiceServiceType.Baggage:
                return React.createElement(Baggage, Object.assign({}, props));
            case OrderAdditionalServiceGdsServiceServiceType.Meal:
                return React.createElement(Meal, Object.assign({}, props));
            case OrderAdditionalServiceGdsServiceServiceType.Seat:
                return React.createElement(Seat, Object.assign({}, props));
        }
        return null;
    };
    const renderServicesCard = React.useMemo(() => {
        const services = [];
        groupServices === null || groupServices === void 0 ? void 0 : groupServices.forEach((value, key) => {
            if (Object.keys(value).length > 0) {
                services.push(getServiceCardByType(value, key));
            }
        });
        if ((insurancesRefund === null || insurancesRefund === void 0 ? void 0 : insurancesRefund.length) && (flight === null || flight === void 0 ? void 0 : flight.segmentGroups) !== undefined) {
            services.push(React.createElement(RefundSummaryInsuranceOverride, { services: insurancesRefund }));
        }
        if (services.length) {
            return services.map((component, key) => {
                return React.createElement(React.Fragment, { key: key }, component);
            });
        }
        return null;
    }, [groupServices, insurancesRefund, flight, mode]);
    const WarningMessage = useCallback(() => {
        if (customWarningMessage) {
            return customWarningMessage;
        }
        return (React.createElement("div", { className: theme.warningMessage },
            notification && React.createElement("div", { className: theme.notifications }, notification),
            React.createElement("div", { className: cn(theme.services, className) }, renderServicesCard)));
    }, [isLoading, notification, renderServicesCard, customWarningMessage]);
    return (React.createElement(React.Fragment, null,
        isLoading && (React.createElement("div", { className: cn(theme.container, className) },
            React.createElement(CardExtraViewSkeleton, null),
            React.createElement(CardExtraViewSkeleton, null),
            React.createElement(CardExtraViewSkeleton, null))),
        !isLoading && !!renderServicesCard && React.createElement(WarningMessage, null)));
};
export default RefundSummary;
